import { render, staticRenderFns } from "./printing_together.vue?vue&type=template&id=f3665eee&scoped=true"
import script from "./printing_together.vue?vue&type=script&lang=js"
export * from "./printing_together.vue?vue&type=script&lang=js"
import style0 from "./printing_together.vue?vue&type=style&index=0&id=f3665eee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3665eee",
  null
  
)

export default component.exports